export function getFileName(filePath="") {
  const fileName = filePath?.split(/[/\\]/).pop(); 
  const dotIndex = fileName?.lastIndexOf('.');
  return dotIndex !== -1 ? fileName?.substring(0, dotIndex) : fileName;
}
